export default __webpack_public_path__ + "77d17af710dabaff8a30c6d200f7292a.svg";